<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';
import NextInput from 'dashboard/components-next/input/Input.vue';

import { isPhoneE164OrEmpty } from 'shared/helpers/Validators';

export default {
  components: {
    NextButton,
    NextInput,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      phoneNumber: '',
      apiKey: '',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
    phoneNumber: { required, isPhoneE164OrEmpty },
    apiKey: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const whatsappChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName?.trim(),
            channel: {
              type: 'whatsapp',
              phone_number: this.phoneNumber,
              provider_config: {
                api_key: this.apiKey,
              },
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: whatsappChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-col gap-5" @submit.prevent="createChannel()">
    <fieldset class="min-w-0 p-5 border rounded-xl border-n-weak bg-n-solid-1">
      <div class="flex flex-col gap-4">
        <NextInput
          v-model="inboxName"
          :label="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL')"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          :message="
            v$.inboxName.$error
              ? $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR')
              : ''
          "
          :message-type="v$.inboxName.$error ? 'error' : 'info'"
          @blur="v$.inboxName.$touch"
        />
        <NextInput
          v-model="phoneNumber"
          :label="$t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.LABEL')"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.PLACEHOLDER')"
          :message="
            v$.phoneNumber.$error
              ? $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.ERROR')
              : ''
          "
          :message-type="v$.phoneNumber.$error ? 'error' : 'info'"
          @blur="v$.phoneNumber.$touch"
        />
        <NextInput
          v-model="apiKey"
          :label="$t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.LABEL')"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.PLACEHOLDER')"
          :message="
            v$.apiKey.$error ? $t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.ERROR') : ''
          "
          :message-type="v$.apiKey.$error ? 'error' : 'info'"
          @blur="v$.apiKey.$touch"
        />
      </div>
    </fieldset>

    <div class="flex justify-end">
      <NextButton
        type="submit"
        :label="$t('INBOX_MGMT.ADD.WHATSAPP.SUBMIT_BUTTON')"
        :is-loading="uiFlags.isCreating"
      />
    </div>
  </form>
</template>
